<template>
    <div v-if="canShow('经络辨证') && info && info.tizhi_jingluo">
        <div class="tips"></div>
        <div class="sick-box">
            <div class="risk">经络辨证</div>
        </div>
        <div class="assessment">
            <div class="sick-list flex flex-w">
                <div class="new-sick new-easy" :class="{ active: info.tizhi_text_array[sutra_index] == item }" v-for="(item, index) in info.tizhi_text_array" :key="index" @click="() => isSutreFun(index)">
                    {{ item }}<span v-if="info.report_type == 1">({{ index == 0 ? '主' : '兼' }})</span>
                </div>
            </div>
            <div class="inner-top" v-for="(item, index) in info.tizhi_jingluo" :key="index">
                <div v-if="info.tizhi_text_array[sutra_index] == index">
                    <div class="flex inner-name">
                        <div class="flex-1">{{ item.Jingluo }}</div>
                        <div>{{ item.JingluoStatus }}</div>
                    </div>
                    <div class="sick-title">经络说明</div>
                    <div>{{ item.JingluoDesc }}</div>
                    <div class="sick-title">状态</div>
                    <div>{{ item.Status }}</div>
                    <div class="sick-title">推荐穴位</div>
                    <div v-html="item.Xuewei"></div>
                    <div class="sick-title">调理方法</div>
                    <div>{{ item.Tiaoli }}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import { moduleMixin } from '../helpers';

export default {
    name: 'ReportJingluo',
    mixins: [moduleMixin],
    data() {
        return {
            sutra_index: 0
        };
    },
    computed: {
        ...mapState('report', ['info'])
    },
    methods: {
        isSutreFun(data) {
            this.sutra_index = data;
        }
    }
};
</script>
<style lang="scss" scoped>
@import './Jingluo.scss';
</style>
